import { useLocation, useNavigate } from 'react-router';
import { getPaymentStatus } from '../apis/paymentApi';
import { Loader } from '../controls/Loader';
import { Helmet } from 'react-helmet';
import { useQuery } from '@tanstack/react-query';

export const VNPayReturn = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const {
    data,
    error,
    isFetching: isValidating,
  } = useQuery({
    queryKey: [`api/vnpay/verify_callback`, search],
    queryFn: () => getPaymentStatus(search),
    retry: 3,
    retryDelay: 3000,
  });

  if (isValidating) {
    return <Loader />;
  }

  if (error) {
    return <div>Error</div>;
  }

  navigate({
    pathname: `/${data.hotelId}/reservation/${data.reservationId}`,
  });
};

export const VNPayReturnPage = () => {
  return (
    <>
      <Helmet>
        <title>{`Thanh toán VNPay`}</title>
      </Helmet>
      <VNPayReturn />
    </>
  );
};
